import PropTypes from 'prop-types';
import {crossfilter} from 'dc';
import * as chartsUtilFunctions from './util/chartsUtilFunctions';
import * as utilFunctions from './util/utilFunctions';
 
class CrossfilterBase {
  constructor(props) {
    this.state = {
      dim: null,
      dimGroupFunction: null,
      valueAccesor: (function(p) { return p.value; }),
      metrics: [],
      metricsLabels: []
    }; 
    this.props = props;
  }

  getDim() {
  	return this.state.dim;
  }

  getMetrics() {
  	return this.state.metrics;
  }

  getMetricsLabels() {
  	return this.state.metricsLabels;
  }

  getValueAccesor() {
  	return this.state.valueAccesor;
  }

  setDimGroupFunction() {
    switch(this.props.dimension.reduceFunction.type) {
      case "DISCRETE_GROUP":
        if("parameters" in this.props.dimension.reduceFunction) {
          var categoriesArray = this.props.dimension.reduceFunction.parameters.categories;
          var categoriesLabelsArray = this.props.dimension.reduceFunction.parameters.labels;
          var categoriesParser = this.props.dimension.reduceFunction.parameters.categoriesParser
          var isInRangeFunction = chartsUtilFunctions.isInRange;
          
          //revisar, puede ser recurso intensiva con data sets grandes
          this.state.dimGroupFunction = (
            function(d) {
              for(var i=0;i<categoriesArray.length;i++) {   
                if(isInRangeFunction(categoriesArray[i],d,[],categoriesParser)) {
                  return categoriesLabelsArray[i];
                }
              }
              return "_outofrange_";
            }
          );
        }
        else {
          this.state.dimGroupFunction = (function(d) { return d; });
        }
        break;
      case "CONTINUOUS_GROUP":
        this.state.dimGroupFunction = (function(d) { return d; });
        break;
    }    
  }

  setDimension(createCleanDimension = false) {
    var runFormatFunctions = chartsUtilFunctions.runFormatFunctions;
    var componentDimIdentifier = this.props.dimension.name + 
      JSON.stringify(this.props.dimension.formatFunction) + 
      JSON.stringify(this.props.dimension.reduceFunction);
    
    if(componentDimIdentifier in this.props.crossfilerData.componentDims) {
      this.state.dim = this.props.crossfilerData.componentDims[componentDimIdentifier];
    }
    else {
      this.state.dim = this.props.crossfilerData.dimension((function(_dimGroupFunction,_formatFunction,_name,d) {
      	  return _dimGroupFunction(runFormatFunctions(_formatFunction, d[_name]));
        }).bind(null,this.state.dimGroupFunction,this.props.dimension.formatFunction,this.props.dimension.name));
      this.props.crossfilerData.componentDims[componentDimIdentifier] = this.state.dim;
    }
  }

  generateMetrics() {
    for(var i=0;i<this.props.metrics.length;i++) {
      var metricParams = this.props.metrics[i];
      var metricGroup;
      var checkFiltersFunction = chartsUtilFunctions.checkFilters;
      var removeBinFunction = chartsUtilFunctions.remove_bins;
      var ensureGroupBins = chartsUtilFunctions.ensure_group_bins;
      var removeEmptyBins = chartsUtilFunctions.remove_empty_bins;
      var rankFunction = chartsUtilFunctions.rank_group;
      var filterFunction = (
        function (_metricParams, d) { 
          if(checkFiltersFunction(_metricParams.filter,d)) {
            return d[_metricParams.metric];
          }
          return 0; 
        }
      ).bind(this, metricParams);      

      switch(metricParams.reduceFunction.type) {
        case "FIRST_VALUE":
          metricGroup = this.state.dim.group().reduce(
            chartsUtilFunctions.crossfilterReduceAddFirstValue(metricParams), 
            chartsUtilFunctions.crossfilterReduceRemoveFirstValue(metricParams), 
            chartsUtilFunctions.crossfilterReduceInitFirstValue
          );
          break;
        case "SUM":
          metricGroup = this.state.dim.group().reduce(
            chartsUtilFunctions.crossfilterReduceAddSum(metricParams), 
            chartsUtilFunctions.crossfilterReduceRemoveSum(metricParams), 
            chartsUtilFunctions.crossfilterReduceInitSum
          );
          break;
        case "COUNT":
          metricGroup = this.state.dim.group().reduce(
            chartsUtilFunctions.crossfilterReduceAddCount(metricParams), 
            chartsUtilFunctions.crossfilterReduceRemoveCount(metricParams), 
            chartsUtilFunctions.crossfilterReduceInitCount
          );
          break;
        case "AVG":
          metricGroup = this.state.dim.group().reduce(
            chartsUtilFunctions.crossfilterReduceAddAvg(metricParams), 
            chartsUtilFunctions.crossfilterReduceRemoveAvg(metricParams), 
            chartsUtilFunctions.crossfilterReduceInitAvg
          );
          break;
        case "POND_AVG":
          metricGroup = this.state.dim.group().reduce(
            chartsUtilFunctions.crossfilterReduceAddPondAvg(metricParams), 
            chartsUtilFunctions.crossfilterReduceRemovePondAvg(metricParams), 
            chartsUtilFunctions.crossfilterReduceInitPondAvg
          );
          break;
        case "PCT_COUNT_GROUP":
          metricGroup = this.state.dim.group().reduce(
            chartsUtilFunctions.crossfilterReduceAddPctCountGroup(metricParams), 
            chartsUtilFunctions.crossfilterReduceRemovePctCountGroup(metricParams), 
            chartsUtilFunctions.crossfilterReduceInitPctCountGroup
          );
          break;
        case "PCT_SUM_COLUMN":
          metricGroup = this.state.dim.group().reduce(
            chartsUtilFunctions.crossfilterReduceAddPctSumColumn(metricParams), 
            chartsUtilFunctions.crossfilterReduceRemovePctSumColumn(metricParams), 
            chartsUtilFunctions.crossfilterReduceInitPctSumColumn
          );          
          break;
        case "COUNT_IF_POND_AVG":
          metricGroup = this.state.dim.group().reduce(
            chartsUtilFunctions.crossfilterReduceAddCountIfPongAvg(metricParams), 
            chartsUtilFunctions.crossfilterReduceRemoveCountIfPongAvg(metricParams), 
            chartsUtilFunctions.crossfilterReduceInitCountIfPongAvg
          );          
          break;
      }
      this.state.valueAccesor = (function(p) { return p.value.value; });     

      var auxMetric = metricGroup;

      removeBinFunction = removeBinFunction.bind(null,auxMetric);
      auxMetric = removeBinFunction(["_outofrange_"]); 

      if(this.props.dimension.reduceFunction.type == "DISCRETE_GROUP" 
        && "parameters" in this.props.dimension.reduceFunction) {
        ensureGroupBins = ensureGroupBins.bind(null,auxMetric);
        auxMetric = ensureGroupBins(0, this.props.dimension.reduceFunction.parameters.labels);
      }

      if(this.props.dimension.reduceFunction.type == "CONTINUOUS_GROUP") {
        removeEmptyBins = removeEmptyBins.bind(null,auxMetric);
        auxMetric = removeEmptyBins(); 
      }

      if("rank" in metricParams.reduceFunction && metricParams.reduceFunction.rank == true) {        
        if("order" in metricParams.reduceFunction) {
          rankFunction = rankFunction.bind(null,auxMetric,metricParams.reduceFunction.order);
          auxMetric = rankFunction();
        }
        else {
          rankFunction = rankFunction.bind(null,auxMetric);
          auxMetric = rankFunction("DESC");
        }
      }

      auxMetric.name = metricParams.name;
      auxMetric.config = metricParams.config;
      this.state.metrics[i] = auxMetric;
      this.state.metricsLabels[i] = metricParams.name;
    }
  }

  processCrossfilter(generateMetrics = true) { 
    this.setDimGroupFunction();
    this.setDimension();
    if(generateMetrics == true) {
      this.generateMetrics();
    }
  }
}

CrossfilterBase.propTypes = {
  id: PropTypes.string.isRequired,
  crossfilerData: PropTypes.object.isRequired,
  dimension: PropTypes.shape({
    originalName: PropTypes.any.isRequired,
    formatFunction: PropTypes.array.isRequired,
    reduceFunction: PropTypes.oneOfType([ //CONTINUOS GROUP ELIMINA LOS BINS VACIOS Y DISCRETE GROUP LOS ASEGURA TODOS
      PropTypes.shape({
        type: PropTypes.oneOf(['CONTINUOUS_GROUP']).isRequired,
        typeof: PropTypes.oneOf(['NUMBER','DATE_TIME','STRING']).isRequired,
      }),
      PropTypes.shape({
        type: PropTypes.oneOf(['DISCRETE_GROUP']).isRequired,
        typeof: PropTypes.oneOf(['NUMBER','DATE_TIME','STRING']).isRequired,
        parameters: PropTypes.shape({          
          categories: PropTypes.arrayOf(PropTypes.arrayOf(utilFunctions.rangePropType())).isRequired,
          labels: PropTypes.arrayOf(PropTypes.string).isRequired,
          categoriesParser: PropTypes.array.isRequired,
        })
      })
    ]).isRequired
  }).isRequired,
  metrics: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    formatFunction: PropTypes.array.isRequired,
    reduceFunction: PropTypes.shape({
      type: PropTypes.oneOf(['SUM','COUNT','AVG','POND_AVG','PCT_COUNT_GROUP','PCT_SUM_COLUMN','FIRST_VALUE','COUNT_IF_POND_AVG']).isRequired,
      column: PropTypes.any, //if PCT_SUM_COLUMN or POND_AVG is required
      rank: PropTypes.bool, //PARA RANKEAR
      order: PropTypes.oneOf(['DESC','ASC']), //PARA RANKEAR define el orden//por defecto esta en DESC
      column_group: PropTypes.any, //solo para COUNT_IF_POND_AVG
      filters: PropTypes.arrayOf(utilFunctions.rangePropType()) //solo para COUNT_IF_POND_AVG
    }).isRequired,
    filter: PropTypes.arrayOf(PropTypes.shape({
      dimension: PropTypes.any.isRequired,
      formatFunction: PropTypes.array.isRequired,
      filterParser: PropTypes.array.isRequired,
      filters: PropTypes.arrayOf(utilFunctions.rangePropType()).isRequired
    })).isRequired,
    config: PropTypes.shape({
    //to be implemented by child classes, it is going to be replaced                              
    }).isRequired,
  })).isRequired
};

export default CrossfilterBase;


// WEBPACK FOOTER //
// ./source/client/components/common/graphs/crossfilterGraphs/crossfilterBase.js